import {
  ASSET_TYPE_LIST, ASSET_TYPE_LIST_SUCCESS, ASSET_TYPE_LIST_FAILURE,
  ASSET_TYPE_DATA, ASSET_TYPE_DATA_SUCCESS, ASSET_TYPE_DATA_FAILURE,
  ASSET_TYPE_CREATE, ASSET_TYPE_CREATE_SUCCESS, ASSET_TYPE_CREATE_FAILURE,
  ASSET_TYPE_UPDATE, ASSET_TYPE_UPDATE_SUCCESS, ASSET_TYPE_UPDATE_FAILURE,
  ASSET_TYPE_DELETE, ASSET_TYPE_DELETE_SUCCESS, ASSET_TYPE_DELETE_FAILURE,
} from "./actionType";

export const assetTypeList = () => ({ type: ASSET_TYPE_LIST });
export const assetTypeListSuccess = (data) => ({ type: ASSET_TYPE_LIST_SUCCESS, payload: data });
export const assetTypeListFailure = (error) => ({ type: ASSET_TYPE_LIST_FAILURE, payload: error });

export const assetTypeData = (data) => ({ type: ASSET_TYPE_DATA, payload: data });
export const assetTypeDataSuccess = (data) => ({ type: ASSET_TYPE_DATA_SUCCESS, payload: data });
export const assetTypeDataFailure = (error) => ({ type: ASSET_TYPE_DATA_FAILURE, payload: error });

export const assetTypeCreate = (data) => ({ type: ASSET_TYPE_CREATE, payload: data });
export const assetTypeCreateSuccess = (data) => ({ type: ASSET_TYPE_CREATE_SUCCESS, payload: data });
export const assetTypeCreateFailure = (error) => ({ type: ASSET_TYPE_CREATE_FAILURE, payload: error });

export const assetTypeUpdate = (data) => ({ type: ASSET_TYPE_UPDATE, payload: data });
export const assetTypeUpdateSuccess = (data) => ({ type: ASSET_TYPE_UPDATE_SUCCESS, payload: data });
export const assetTypeUpdateFailure = (error) => ({ type: ASSET_TYPE_UPDATE_FAILURE, payload: error });

export const assetTypeDelete = (data) => ({ type: ASSET_TYPE_DELETE, payload: data });
export const assetTypeDeleteSuccess = (data) => ({ type: ASSET_TYPE_DELETE_SUCCESS, payload: data });
export const assetTypeDeleteFailure = (error) => ({ type: ASSET_TYPE_DELETE_FAILURE, payload: error });
